import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { MonthlyResultsMono as Component } from './MonthlyResultsMono.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

type IInjectedProps = IStateProps & IDispatchProps;

export type IProps = IInjectedProps;

const mapStateToProps = (rootState: IRootState) => ({
  routeMonoSimulationGroup: selectRouteResource(rrc.mono_simulation_group)(rootState),
});

const mapDispatchToProps = {};

export const MonthlyResultsMono = connect(mapStateToProps, mapDispatchToProps)(Component);
